<template>
  <div class="main">
    <div class="box">
      <el-input v-model="input" placeholder="请输入还原的用户手机号"></el-input>
      <el-row>
        <el-button type="primary" @click="search">一键修改</el-button>
      </el-row>
    </div>

    <div class="mini">输入用户手机号，即可还原成默认密码（手机号）</div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";

export default {
  data() {
    return {
      input: ""
    };
  },
  created() {},

  methods: {
    search() {
      let obj = {
        username: this.input
      };
      require("post", "/hr24_user/v1/restore_password/", obj).then(res => {
        if (!res.code) {
          this.$message({
            message: res.msg,
            type: "success"
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
 

.mini {
  font-size: 14px;
  color: #ccc;
}

.el-input {
  width: 20%;
  margin-right: 5px;
}

.box {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/user_management/change_psd.vue